(ns dre.app.events
  (:require
    [applied-science.js-interop :as j]
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [dre.config :as conf]
    [dre.network :as-alias network]
    [dre.processes.bootstrap :as-alias bs]
    [re-frame.core :as rf]))


(def db-path :app)


;; -- Events

(rf/reg-event-fx
  ::init ; The application entrypoint
  (fn-traced
    [_ [_ opts]]
    {::hide-loader nil
     :fx [[:dispatch [::bs/init opts]]]}))


(rf/reg-fx
  ::hide-loader
  (fn []
    (-> (js/document.getElementById "litsearch-loader")
        (j/assoc-in! [:style :display] "none"))))


(rf/reg-event-fx
  ::logout
  (fn-traced
    [_ _]
    {::network/request [{:endpoint :auth/logout}
                        {:request-content-type :text
                         :response-content-type :text
                         :on-success [::redirect-to-sso]}]}))


(rf/reg-event-db
  ::redirect-to-sso
  (fn-traced
    [db _]
    (set! js/window.location.href (conf/->sso-url db))))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))

(rf/reg-sub
 ::db
 (fn [db _]
   db))


(rf/reg-sub
  ::status
  :<- [::state]
  (fn [db _]
    (:state db)))


(rf/reg-sub
  ::user
  :<- [::state]
  (fn [db _]
    (:user db)))

;; (rf/reg-sub
;;  ::segment-writekey
;;  :<- [::state]
;;  (fn [db _]
;;    (:segment-writekey db)))
